import { StandardTag, isStandardTag } from "@aidkitorg/types/lib/tags";
import { useLocalizedStrings } from "../Localization";
import { useContext, useMemo } from "react";
import { PublicConfigurationContext } from "../Context";
import { Badge, Tooltip } from "@aidkitorg/component-library";

export const useTagDetails = (possibleTag: StandardTag | string) => {
  const L = useLocalizedStrings();
  const configContext = useContext(PublicConfigurationContext);

  const tag = isStandardTag(possibleTag) ? possibleTag : undefined;
  
  const tagDetails = useMemo(() => {
    // TODO, something like this:
    // if (configContext.capabilities?.customTags) {
    //   const customTag = configContext.capabilities.customTags.find(t => t.tag === tag);
    //   if (customTag) {
    //     return { name: customTag.name, description: customTag.description };
    //   }
    // }
    return {
      name: tag ? L.permissions[tag].name : possibleTag,
      description: tag ? L.permissions[tag].description : possibleTag
    }
  }, [tag, configContext, L.permissions]);

  return tagDetails;
}

export const TagBadge = ({ tag }: { tag: StandardTag | string }) => {
  const tagDetails = useTagDetails(tag);
  return <Tooltip text={tagDetails.description} asChild={true}>
    <span>
      <Badge key={tag} variant="neutral">{tagDetails.name}</Badge>
    </span>
  </Tooltip>
}